<!-- 获取定位弹窗 -->
<template>
  <div class="location-popup">
    <van-overlay
      :show="show"
      @click="close"
      :lock-scroll="false"
      class="my-overlay"
    >
      <div class="wrapper" @click.stop>
        <div class="location-content">
          <!-- <img
            src="@/assets/imgs/putianPostalNationalDayLottery/location.jpg"
            alt=""
            class="pic"
          /> -->
          <h4 class="title">
            {{ " 为了让您顺利参加活动\n请先授权地理位置" }}
          </h4>
          <van-button class="btn" @click="submit" color="#e44d4d"
            >获取地理位置授权</van-button
          >
          <p class="tip">注：请打开设置-微信APP-设置</p>
        </div>
      </div>
      <img
        class="close"
        @click="close"
        :src="require(`@/assets/imgs/putianPostalNationalDayLottery/close.png`)"
        alt=""
      />
    </van-overlay>
  </div>
</template>
<script>
import { Toast } from 'vant'
export default {
  components: {},
  props: [],
  data() {
    return {
      show: false,
    }
  },
  methods: {
    close() {
      this.setShow(false)
    },
    setShow(val) {
      this.show = val
    },
    submit() {
      this.$emit('submit')
    },
  },
}
</script>
<style lang="less" scoped>
.location-popup {
  position: relative;
  .my-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .wrapper {
    padding: 30px 20px;
    width: 250px;
    box-sizing: border-box;
    border: 5px solid #abd0fa;
    background: #ddecff;
    border-radius: 10px;
    text-align: center;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .pic {
      width: 80px;
    }

    .title {
      padding: 10px 0;
      line-height: 1.3;
      font-weight: bold;
      font-size: 18px;
      white-space: pre-wrap;
    }
    .tip {
      line-height: 1.2;
      font-size: 14px;
    }
    .btn {
      margin: 35px;
      width: 160px;
    }
  }
  .close {
    margin-top: 20px;
    width: 35px;
  }
}
</style>
